import { useEffect, useState } from "react";
import client from "@/lib/api";

// Feature flags for MATCOM add-ons. Admin toggles them in /addons.
export default function useAddons() {
  const [flags, setFlags] = useState({});
  useEffect(() => {
    client.get("/addons").then((r) => {
      const m = {};
      (r.data.addons || []).forEach((a) => { m[a.key] = a.enabled; });
      setFlags(m);
    }).catch(() => {});
  }, []);
  return flags;
}
